
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShipHighspeed as ObiShipHighspeedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ship-highspeed.js';
 
 
 

 
 export const ObiShipHighspeed = createComponent({
   react: React,
   tagName: 'obi-ship-highspeed',
   elementClass: ObiShipHighspeedElement,
   events: {
     
   }
  });
 
 